import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {AutocompleteProvider, AutocompleteProviderConfig} from '../../autocomplete';
import {DynamicZyxDaemonService} from '../../dynamic-xyz/dynamic-zyx-daemon.service';

@Injectable()
export class DexWalletAutocompleteService implements AutocompleteProvider<string> {

    constructor(
        private dynamicZyxDaemonService: DynamicZyxDaemonService
    ) {}

    public autocomplete(term: string, config?: AutocompleteProviderConfig<string>): Observable<string[]> {
        const MAX_COUNT = 7;

        const filtered: string[] = [];
        const preparedTerm = (term || '').toLocaleLowerCase();

        for (const w of this.dynamicZyxDaemonService.dynRemote.userWallets$.value) {
            if (filtered.length >= MAX_COUNT) {
                break;
            }

            if (!w.address.toLocaleLowerCase().startsWith(preparedTerm)) {
                continue;
            }

            filtered.push(w.address);
        }

        return of(filtered);
    }

}
